import { Component, OnInit, Input, Inject, Output, EventEmitter } from 'ng-metadata/core';
import { GetItRequestService } from './getItRequest.service';
import { FormBuilderEnums } from '../../../../infra/formBuilder/formBuilder.service';
import { NgrsService } from '../ngrs.service';
import { PhysicalBestOfferService } from '../physicalBestOffer/physicalBestOffer.service';
import { UserSessionManagerService } from '../../../../security/userSessionManager.service';
import {getVid, isShowPhysicalJournalOffer} from '../../../..//appConfig/appConfigForward';
import { forEach } from 'angular';
import { getResourceType, getGenreType } from '../../../../infra/ngrsUtil';
import {SmoothScrollUtil} from '../../../../nddUtils/smoothScrollUtil.service';
import { PickupAnywhereService } from '../pickup-anywhere-form/pickupAnywhereForm.service';
import {getInstitutionCode} from '../../../../appConfig/appConfigForward';
import {mmsIdOfferOutputMap} from '../BestOffer.interface';
import {JwtUtilService} from '../../../../security/jwtUtil.service';
import {ConfigurationUtil} from '../../../../nddUtils/configurationUtil.service';
import {PermalinkService} from "../../../actions/permalinkAction/permalink.service";

const get = require('lodash/get');
const lastResortHtml =  'lastResortGetItRequest.html';
const largeHtml =  'bookGetItRequest.html';
const smallHtml =  'otherGetItRequest.html';


@Component({
    "inputs": ['opendigitalform', 'openphysicalform', 'openblankform', 'showmessagebar', 'display', 'offerfound'],
    selector: 'prm-get-it-request',
    templateUrl: 'components/search/fullView/ngrs/getItRequest/getItRequest.html',
})

export class PrmGetItRequest implements OnInit {

    @Input() item: Object;
    @Input() bestoffer: Object;
    @Input() digitalbestoffer: Object;
    @Input() private isdigitaloffer: boolean;
    @Input() private isblankform: boolean;
    @Input() formscustomization: any;

    private vid: string = getVid();
    private _alternativeEmailCode: string;
    private _formData: Object = {};
    private _isDigitalFormValid: boolean;
    private _isEBookFormValid: boolean;
    private _isPhysicalJournalFormValid: boolean;
    private _isLargeForm: boolean;
    private _borrowingRequestMessage: string;
    private _borrowingRequestOK: boolean;
    private _showCopyRightsStatement = false;
    private _requestSubmitted = false;
    private _showRequestFormMessage = false;
    private focusedAlternativeEmail:boolean = false;
    private _pickupAnywhereEnabled: boolean = false;
    private _refineOfferDisabled: boolean = true;
    private _refineOfferInProgress: boolean = false;
    private _refined : boolean = false;
    private _canRestore: boolean = false;
    private _bestOffer: Object = {};
    private _mmsId: string;
    private _requestFormMessage;
    private isChapterFormValid: boolean = true;
    private _pickupInstitutionAndLocationMap: Object = {};
    private _pickupInstitutionDefault: string;
    private _pickupLibraryDefault: string;
    private _pickupLocationLocal: Object = {};
    private _isPuaOffer: boolean = false;
    private _showSubMenuForPua: boolean = true;
    private _dateField = {
        name: 'myDate', label: '', uiType: FormBuilderEnums.UI_TYPE.DATE, placeHolder: 'nui.ngrs.request.physical.date_needed_by', populator: {
            params: {
                allow: FormBuilderEnums.FUTURE_DATES
            }
        },  mandatory:false, mandatoryIndicator:false
    };
    private _volumeField = { name: 'myVolume', label: 'nui.ngrs.request.volume', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator: false };
    private _noteField = { name: 'myNote', label: 'nui.ngrs.request.note', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator: false };
    private _locationField = {
        key: 'pickupLocation',
        name: 'myLocation',
        mandatory: true,
        mandatoryIndicator: true,
        path: 'groups-list-map/pickupLocation',
        label: 'nui.ngrs.pickup.information.pickupLibrary',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
        populator: {
            params: {
                byCategory: true
            }
        }
    };
    private _pickupMembersField = {
        key: 'pickupMembers',
        name: 'myPickupMember',
        mandatory: true,
        mandatoryIndicator: true,
        path: 'groups-list-map/pickupMembers',
        label: 'nui.ngrs.pickup.information.pickupLibrary',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
        events: {
            onChange: this.setPickupMember.bind(this)
        }
    };
    private _pickupInstitutionFNField = {
        key: 'pickupInstitution',
        name: 'myPickupInstitution',
        mandatory: true,
        value: '',
        mandatoryIndicator: true,
        path: 'ful-net-rs-groups-list-map/preferredPickupInstitution',
        label: 'almaResourceSharing.pickupInstitution',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
        events: {
            onChange: this.setPickupLibrariesLocation.bind(this)
        }
    };
    private _pickupLibraryFNField = {
        key: 'pickupLibrary',
        name: 'myPickupLibrary',
        mandatory: true,
        value: '',
        mandatoryIndicator: true,
        path: 'ful-net-rs-groups-list-map/preferredPickupLocation',
        label: 'nui.ngrs.pickup.information.pickupLibrary',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH
    };
    private _locationFieldForEBookRequest = {
        key: 'pickupLocationForEBook',
        name: 'myLocationForEBook',
        mandatory: false,
        mandatoryIndicator: false,
        path: 'groups-list-map/pickupLocation',
        label: 'nui.ngrs.pickup.information.pickupLibraryForEBook',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN_WITH_FILTER_SEARCH,
        populator: {
            params: {
                byCategory: true
            }
        }
    };
    private _emailField = {
        name: 'myEmail',
        label: 'nui.ngrs.request.digital.email',
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
        mandatory: true,
        mandatoryIndicator : true
    };
    private _alternativeEmailField = {
        name: 'myAlternativeEmail',
        label: 'nui.ngrs.request.digital.alternative_email',
        uiType: FormBuilderEnums.UI_TYPE.TEXT,
        mandatory: true,
        mandatoryIndicator : true
    };
    private _articleTitleField = { name: 'myArticleTitle', label: 'nui.ngrs.request.journal.article.title', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator:true};
    private _articleAuthorField = { name: 'myArticleAuthor', label: 'nui.ngrs.request.journal.article.author', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _issueField = { name: 'myIssue', label: 'nui.ngrs.request.journal.issue', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _publicationDateField = { name: 'myPublicationDate', label: 'nui.ngrs.request.journal.publication.date', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _chapterTitleField = { name: 'myChapterTitle', label: 'nui.ngrs.request.digital.chapter_title', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _chapterAuthorField = { name: 'myChapterAuthor', label: 'nui.ngrs.request.digital.chapter_author', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _chapterNumberField = { name: 'myChapterNumber', label: 'nui.ngrs.request.digital.chapter_number', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _fromPageField = { name: 'myFromPage', label: 'nui.ngrs.request.digital.from_page', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _toPageField = { name: 'myToPage', label: 'nui.ngrs.request.digital.to_page', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _composerField = { name: 'myComposer', label: 'nui.ngrs.request.digital.composer', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _opusField = { name: 'myOpus', label: 'nui.ngrs.request.digital.opus', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _songMovementField = { name: 'mySongMovement', label: 'nui.ngrs.request.digital.song_movement', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _partField = { name: 'myPart', label: 'nui.ngrs.request.digital.part', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator:false};
    private _allowOtherFormats = { label: "nui.ngrs.request.no_offer.allow_digital", checked: false };
    private _copyRightsCheckBoxField = {
        name: 'copyRightsRapido',
        uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
        mandatory: true,
        mandatoryIndicator: true,
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        value: '',
        options: [
            {
                name: 'copyRights',
                label: 'nui.ngrs.request.no_offer.book',
                value: false,
            }
        ]
    }
    private _levelOfServiceField = {
        name: 'myLevelOfService',
        label: 'nui.ngrs.request.digital.level_of_service',
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
        mandatory: false,
        mandatoryIndicator: false
    };


    constructor(private getItRequestService: GetItRequestService,
        private ngrsService: NgrsService,
        private jwtUtilService: JwtUtilService,
        private userSessionManagerService: UserSessionManagerService,
        private physicalBestOfferService: PhysicalBestOfferService,
        private permalinkService: PermalinkService,
        private smoothScrollUtil : SmoothScrollUtil,
        private pickupAnywhereService: PickupAnywhereService,
        private configurationUtil: ConfigurationUtil,
        @Inject('$sce') private $sce,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('actionIcons') private  actionIcons: Object,
        @Inject('$translate') private $translate,
        @Inject('$scope') private $scope: ng.IScope) {
        this._pickupAnywhereEnabled = window.appConfig['system-configuration'].ngrs_pickup_anywhere;
        this._bestOffer = this.bestoffer;
        let reqParams = { 'vid': this.vid };
        this.itemDetailsRequest = {
            'AlmaResourceSharing': {
                'allowed': "Y",
                'link-to-service': "/primaws/rest/priv/ILSServices/titleServices/-1/-1/AlmaResourceSharing?institution=",
                'service-type': "OvP",
                'type': "AlmaResourceSharing"
            }
        };
        this._showRequestFormMessage = false;
        this.setMandatoryFields();
        if (this.isblankform) {
            this.physicalBestOfferService.getEmailList().then((response) => this.setEmail(response));
            this.physicalBestOfferService.getPickupLocation(false).then((response) => this.setPickupLocation(response));
            this.physicalBestOfferService.getCopyRightsStatement().then((response) => this.setCopyRightsStatement(response));
        }
        else if (this.isDigitalOffer()) {
            this.physicalBestOfferService.getEmailList().then((response) => this.setEmail(response));
            this.physicalBestOfferService.getCopyRightsStatement().then((response) => this.setCopyRightsStatement(response));
        } else {
            if(this.isEbookOffer()){
                this.physicalBestOfferService.getEmailList().then((response) => this.setEmail(response));
            }
            if(!this._pickupAnywhereEnabled){
                this.physicalBestOfferService.getPickupLocation(this.isFNRotaOfferDropDowns()).then((response) => this.setPickupLocation(response));
            }
            this._isPuaOffer = this.isPuaOffer();
            if (this._isPuaOffer) {
                this.setupPua();
            }
        }
        let formType = this.isdigitaloffer ? "digital" : this.isEbookOffer() ? "electronic" : "physical";
        this.getItRequestService.getRequestFormMessage(formType).then((response)=> this.setRequestFormMessage(response));

        this.$scope.$watch('$ctrl.formData.myPublicationDate', (newPublicationDate, oldPublicationDate) => {
            this.onPhysicalJournalFieldChange(newPublicationDate, oldPublicationDate);
        }, true);
        this.$scope.$watch('$ctrl.formData.myVolume', (newVolume, oldVolume) => {
            this.onPhysicalJournalFieldChange(newVolume, oldVolume);
        }, true);
        this.setLevelOfServiceOptions(this.formscustomization);

    }

    ngOnInit() {
        //this.physicalBestOfferService.getPickupLocation().then((response) => this.setpickupInstitutionAndLocationMap(response));
        this.$timeout(() => {
            let element = document.querySelector('#offer_request_main_tile') as HTMLElement;
            if (element) {
                element.setAttribute('tabindex', '-1');
                element.focus();
                element.setAttribute('tabindex', '0');
            } else {
                element = document.querySelector('#no_offer_request_main_tile') as HTMLElement;
                if (element) {
                    element.setAttribute('tabindex', '-1');
                    element.focus();
                    element.setAttribute('tabindex', '0');
                }
            }
        }, 100);
        this._isDigitalFormValid = true;
        this._isPhysicalJournalFormValid = true;
        this._isEBookFormValid = true;
    }

    private setupPua(){
        this._locationField.label = this.$translate.instant("nui.ngrs.pickup.information.localPickupLibrary");
        this._pickupMembersField.options = this.parsePickupMemberOptions(this._bestOffer.puaCentralMembers);
        this._pickupMembersField.mandatory = this.isPickupLocationFieldMandatory();
        this._pickupMembersField.mandatoryIndicator = this._pickupMembersField.mandatory;
        this._formData.myPickupMember = -1;
    }

    private parsePickupMemberOptions(options: Record<number, string>) {
        let comboOptions = [];
        if (options != undefined) {
            forEach(options, (option, key) => comboOptions.push({ "label": option, "value": key }));
            comboOptions.sort((a, b) => this.sortMembers(a, b));
        }
        return comboOptions;
    }

    private sortMembers(m1: {value: long, label: string}, m2 : {value: long, label: string}) {
        if (this.isMyInstitutionPickupMember(m1)) {
            return -1;
        } else if (this.isMyInstitutionPickupMember(m2)) {
            return 1;
        }
        return m1.label.localeCompare(m2.label);
    }

    private isMyInstitutionPickupMember(member: {value: long, key: string}) : boolean {
        return  member.value == -1;
    }

    private isPickupLocationFieldMandatory() : boolean{
        return this.isCodeMandatoryForForm('PICKUP_LOCATION')
    }

    private setMandatoryFields(){
        this._articleAuthorField.mandatory = this.isCodeMandatoryForForm('ARTICLE_AUTHOR');
        this._articleAuthorField.mandatoryIndicator = this._articleAuthorField.mandatory;

        this._articleTitleField.mandatory = this.isCodeMandatoryForForm('ARTICLE_TITLE');
        this._articleTitleField.mandatoryIndicator =   this._articleTitleField.mandatory;

        this._issueField.mandatory = this.isCodeMandatoryForForm('ISSUE');
        this._issueField.mandatoryIndicator = this._issueField.mandatory;

        this._publicationDateField.mandatory = this.isCodeMandatoryForForm('PUBLICATION_DATE');
        this._publicationDateField.mandatoryIndicator = this._publicationDateField.mandatory;

        this._chapterTitleField.mandatory = this.isCodeMandatoryForForm('CHAPTER_TITLE');
        this._chapterTitleField.mandatoryIndicator = this._chapterTitleField.mandatory;

        this._chapterAuthorField.mandatory = this.isCodeMandatoryForForm('CHAPTER_AUTHOR');
        this._chapterTitleField.mandatoryIndicator = this._chapterAuthorField.mandatory;

        this._chapterNumberField.mandatory = this.isCodeMandatoryForForm('CHAPTER_NUMBER');
        this._chapterNumberField.mandatoryIndicator = this._chapterNumberField.mandatory;

        this._fromPageField.mandatory = this.isCodeMandatoryForForm('FROM_PAGE_TO_PAGE');
        this._fromPageField.mandatoryIndicator = this._fromPageField.mandatory;

        this._toPageField.mandatory = this.isCodeMandatoryForForm('FROM_PAGE_TO_PAGE');
        this._toPageField.mandatoryIndicator = this._toPageField.mandatory;

        this._composerField.mandatory = this.isCodeMandatoryForForm('COMPOSER');
        this._composerField.mandatoryIndicator = this._composerField.mandatory;

        this._opusField.mandatory = this.isCodeMandatoryForForm('OPUS');
        this._opusField.mandatoryIndicator = this._opusField.mandatory;

        this._songMovementField.mandatory = this.isCodeMandatoryForForm('SONG_MOVEMENT');
        this._songMovementField.mandatoryIndicator = this._songMovementField.mandatory;

        this._partField.mandatory = this.isCodeMandatoryForForm('PART');
        this._partField.mandatoryIndicator = this._partField.mandatory;

        if(this.isDigitalOffer()) {
            this._levelOfServiceField.mandatory = this.isCodeMandatoryForForm('LEVEL_OF_SERVICE_DIGITAL');
        }
        else {
            this._levelOfServiceField.mandatory = this.isCodeMandatoryForForm('LEVEL_OF_SERVICE_PHYSICAL');
        }
        this._levelOfServiceField.mandatoryIndicator = this._levelOfServiceField.mandatory;

        this._emailField.mandatory = this.isCodeMandatoryForForm('EMAIL');
        this._emailField.mandatoryIndicator = this._emailField.mandatory;

        this._alternativeEmailField.mandatory = this.isCodeMandatoryForForm('EMAIL');
        this.alternativeEmailField.mandatoryIndicator = this._alternativeEmailField.mandatory;

        this._dateField.mandatory = this.isCodeMandatoryForForm('NOT_NEEDED_AFTER');
        this._dateField.mandatoryIndicator = this._dateField.mandatory;

        this._noteField.mandatory = this.isCodeMandatoryForForm('NOTE');
        this._noteField.mandatoryIndicator = this._noteField.mandatory;

        this._pickupInstitutionFNField.mandatory = this.isCodeMandatoryForForm('PICKUP_INSTITUTION');
        this._pickupInstitutionFNField.mandatoryIndicator = this._pickupInstitutionFNField.mandatory;

        this._locationField.mandatory = this.isCodeMandatoryForForm('PICKUP_LOCATION');
        this._locationField.mandatoryIndicator = this._locationField.mandatory;

        this._volumeField.mandatory = this.isCodeMandatoryForForm('VOLUME');
        this._volumeField.mandatoryIndicator = this._volumeField.mandatory;

        this._locationFieldForEBookRequest.mandatory = this.isCodeMandatoryForForm('PICKUP_LOCATION_FOR_EBOOK');
        this._locationFieldForEBookRequest.mandatoryIndicator = this._locationFieldForEBookRequest.mandatory;
    }

    public get volumeField() {
        return this._volumeField;
    }

    public get noteField() {
        return this._noteField;
    }

    private setPickupLocation(response) {
        let comboOptions = [];
        forEach(response, (element, value) => {
            if ((value === 'groups-list-map')) {
                forEach(element, (owner) => {
                    comboOptions = this.parseOptions(owner.pickupLocation, comboOptions);
                    comboOptions = this.parseOptions(owner.preferredLocalPickupLocation, comboOptions);
                });
                this._pickupLocationLocal = element;
            }
            if ((value === 'ful-net-rs-groups-list-map')) {
                this._pickupInstitutionAndLocationMap = element;
            }
            if ((value === 'preferredPickupInstitutionDefault')) {
                this._pickupInstitutionDefault = element;
            }
            if ((value === 'preferredLocalPickupLocationDefault')) {
                this._pickupLibraryDefault = element;
            }
        });
        let defaultValue = this.getDefaultValue(response, comboOptions);
        if (defaultValue) {
            this._locationField.mandatory = false;
            this._formData.myLocation = defaultValue;
            this._locationFieldForEBookRequest.mandatory = false;
            this._formData.myLocationForEBook = defaultValue;
        }
        if (!this.isCodeEnabledforForm('PICKUP_LOCATION') && comboOptions.length) {
            this._formData.myLocation = comboOptions[0].value;
        } else {
            this._locationField.options = comboOptions;
        }
        if (!this.isCodeEnabledforForm('PICKUP_LOCATION_FOR_EBOOK') && comboOptions.length) {
            this._formData.myLocationForEBook = comboOptions[0].value;
        } else {
            this._locationFieldForEBookRequest.options = comboOptions;
        }
       if (this.isFNRotaOfferDropDowns()){           
            this.setPickupInstitutionsLocation();       
       }     
    }


    private getDefaultValue(response: any, comboOptions: any[]) {
        if (comboOptions.length == 1) {
            return comboOptions[0].value
        }
        let defaultValueIndexFilter;
        if (this.isFNRotaOfferDropDowns()){
            defaultValueIndexFilter = (element) => element.value == response.pickupLocationDefault;
        } else {
            defaultValueIndexFilter = (element) => element.value == response.preferredLocalPickupLocationDefault;
        }
        let defaultValueIndex = comboOptions.findIndex(defaultValueIndexFilter);
        if (defaultValueIndex > -1) {
            return comboOptions[defaultValueIndex].value;
        }
    }

    private setEmail(response) {
        let emailComboOptions = [];
        forEach(response, (option) => emailComboOptions.push({ "label": option, "value": option }));
        this._emailField.options = emailComboOptions;
        if (emailComboOptions[0]) {
            this._formData.myEmail = emailComboOptions[0].value;
            if (this._emailField.mandatory) {
                this._emailField.mandatoryIndicator = true;
            }
            else {
                this._emailField.mandatory = false;
            }
        }
        this._alternativeEmailCode = emailComboOptions[emailComboOptions.length - 1].value;
    }

    private setLevelOfServiceOptions(formsCustomization) {
        if(((!this.isDigitalOffer() && this.isCodeEnabledforForm('LEVEL_OF_SERVICE_PHYSICAL')) || 
            (this.isDigitalOffer() && this.isCodeEnabledforForm('LEVEL_OF_SERVICE_DIGITAL')))
            && formsCustomization){
            let levelOfServiceOptions = [];
            let responseOptions = formsCustomization.levelOfServiceOptions;
            forEach(Object.keys(responseOptions), (optionKey) => levelOfServiceOptions.push({ "label": responseOptions[optionKey], "value": optionKey }));
            this._levelOfServiceField.options = levelOfServiceOptions;
            if(formsCustomization.defaultLevelOfService){
                this._formData.myLevelOfService = formsCustomization.defaultLevelOfService;
            }
        }
    }

    private setCopyRightsStatement(response) {
        if (response && !this.isEmpty(response)) {
            this._showCopyRightsStatement = true;
            this._copyRightsCheckBoxField.options[0].label = this.$sce.trustAsHtml(response);
        }
    }

    private setRequestFormMessage(response) {
        if (response && !this.isEmpty(response)) {
            this._showRequestFormMessage = true;
            this._requestFormMessage = this.$sce.trustAsHtml(response);
        }
    }

    private isEmpty(response: string): boolean {
        return (response.length === 0 || !response.trim());
    }

    private parseOptions(options, comboOptions) {
        if (options != undefined) {
            options.sort(this.compare);
            options.forEach((option) => comboOptions.push({ "label": option.value, "value": option.key, "category": option.category ? option.category : this.$translate.instant("nui.ngrs.request.no.campus") }));
        }

        return comboOptions;
    }

    private compare(a, b) {
        if (a.category && !b.category) return -1;
        if (!a.category && b.category) return 1;

        if (a.category && b.category) {
            if (a.category.toUpperCase() > b.category.toUpperCase()) return 1;
            if (b.category.toUpperCase() > a.category.toUpperCase()) return -1;
        }

        if (a.value.toUpperCase() > b.value.toUpperCase()) return 1;
        if (b.value.toUpperCase() > a.value.toUpperCase()) return -1;

        return 0;
    }

    public get locationField() {
        return this._locationField;
    }

    public get locationFieldForEBookRequest() {
        return this._locationFieldForEBookRequest;
    }

    public get dateField() {
        return this._dateField;
    }
    public set dateField(value) {
        this._dateField = value;
    }

    public get emailField() {
        return this._emailField;
    }

    public get alternativeEmailField() {
        return this._alternativeEmailField;
    }

    public get articleTitleField() {
        return this._articleTitleField;
    }

    public get articleAuthorField() {
        return this._articleAuthorField;
    }

    public get issueField() {
        return this._issueField;
    }

    public get publicationDateField() {
        return this._publicationDateField;
    }

    public get chapterTitleField() {
        return this._chapterTitleField;
    }

    public get chapterAuthorField() {
        return this._chapterAuthorField;
    }

    public get chapterNumberField() {
        return this._chapterNumberField;
    }

    public get fromPageField() {
        return this._fromPageField;
    }

    public get toPageField() {
        return this._toPageField;
    }

    public get composerField() {
        return this._composerField;
    }
    
    public get opusField() {
        return this._opusField;
    }

    public get songMovementField() {
        return this._songMovementField;
    }
      
    public get partField() {
        return this._partField;
    }

    public get levelOfServiceField() {
        return this._levelOfServiceField;
    }

    public get formData() {
        if (this.canRefinePUAOffer()){
            this._refineOfferDisabled = false;
        } else if(this._formData && this._formData.myVolume && !this.isPhysicalJournal()){
            this._refineOfferDisabled = false;
        } else if(this.isPhysicalJournal() && (this._formData.myVolume || this._formData.myPublicationDate)){
            this._refineOfferDisabled = false;
        } else {
            this._refineOfferDisabled = true;
        }
        return this._formData;
    }

    private shouldRefineAfterChoosingPUAMember() {
        return this.isOtherMemberPickupMode() && !this._refined;
    }

    private canRefinePUAOffer() {
        return this.shouldRefineAfterChoosingPUAMember() || this._canRestore;
    }
    
    public set formData(value) {
        this._formData = value;
    }

    public clearForm() {
        this._formData = {};
        this._copyRightsCheckBoxField.options[0].value = false;

    }

    public refineOffer() {
        this._refineOfferInProgress = true;
        let result = this.ngrsService.getTitleRecordIdFromItem(this.item);
        let mmsIdArr = result[0];
        let globalIndexArr = result[1];
        if(mmsIdArr){
            this._mmsId = mmsIdArr[0];
        }

        if (globalIndexArr && (globalIndexArr[0].indexOf('cdi_globaltitleindex_catalog_') === 0
            || globalIndexArr[0].indexOf('globaltitleindex_catalog_') === 0)) {
            this.physicalBestOfferService.getbestOfferByGlobalIndex(this._mmsId,this.item, this.pickupAnywhereService.getSelectedPickupInformation(), this._formData, false)
                .then(response => this.setBestPhysicalOffer(response));;
        } else {
            this.physicalBestOfferService.getbestOffer(this._mmsId,this.item, this.pickupAnywhereService.getSelectedPickupInformation(), this._formData, false)
                .then(response => this.setBestPhysicalOffer(response));
        }
    }

    private setBestPhysicalOffer(response: mmsIdOfferOutputMap[]) {
        if (this._refineOfferInProgress){
            this._refined = true;
        }
        this._refineOfferInProgress = false;
        this._canRestore = false;
        let hash = this.jwtUtilService.getDecodedToken().userGroup + '_' + this._mmsId;
        let physicalOffer = response[hash].bestPhysicalPolicy;
        if(!physicalOffer){
            physicalOffer = this.getNoOfferOfferDetails();
        }
        if(physicalOffer && (physicalOffer.supplyTime || physicalOffer.loanPeriod)){
            physicalOffer._noOfferAfterRefine = false;
        }else{
            physicalOffer._noOfferAfterRefine = true;
            physicalOffer._showPUANoOfferMessage = this.isOtherMemberPickupMode();
        }
        this._bestOffer = physicalOffer;
    }

    public cancelForm(event) {
        this.opendigitalform.openDigitalForm = false;
        this.openphysicalform.openPhysicalForm = false;
        this.openblankform.openBlankForm = false;
        this.clearForm();
        event.preventDefault();
        event.stopPropagation();

    }

    public submitForm(event) {
        if (this.isFormValid() && this.isCopyRightsApproved()) {
            let currentOfferDetails = this.isdigitaloffer? this.digitalbestoffer:this._bestOffer;
            if(!currentOfferDetails){
                currentOfferDetails = this.getNoOfferOfferDetails();
            }
            this.physicalBestOfferService.createBorrowingRequest(this._formData, this.item, currentOfferDetails, this._alternativeEmailCode, this.isShowCopyRightsStatement(), this.pickupAnywhereService.getSelectedPickupInformation()).then((response) => this.setBorrowingRequestResult(response));
            event.preventDefault();
            event.stopPropagation();
            this._requestSubmitted = true;
        }
    }

    private getNoOfferOfferDetails() {
        let offer = {};
        offer.offerType = 'NONE';
        if (this.isJournal()) {
            offer.policyType = (this.isPhysicalJournal() && !this.isDigitalOffer()) ? "PHYSICAL" : "DIGITAL";
            offer.allowOtherFormat = false;
        } else if (this.isPartOf()) {
            offer.policyType = "DIGITAL";
            offer.allowOtherFormat = false;
        } else if (!this.isdigitaloffer) {
            offer.policyType = "PHYSICAL";
            offer.allowOtherFormat = this._allowOtherFormats.checked;
        } else {
            offer.policyType = "DIGITAL";
            offer.allowOtherFormat = false;
        }
        if (this._bestOffer && this._bestOffer.rotaId) {
            offer.rotaId = this._bestOffer.rotaId;
            offer.loanPeriod = this._bestOffer.loanPeriod;
            offer.supplyTime = this._bestOffer.supplyTime;
        }
        return offer;
    }

    setBorrowingRequestResult(response: any) {
        this.showmessagebar.message = response["reply-text"];
        if (response.status === "ok") {
            this._borrowingRequestOK = true;
            this.showmessagebar.borrowingRequestOK = true;
        } else {
            this._borrowingRequestOK = false;
            this.showmessagebar.borrowingRequestOK = false;
        }
        this.showmessagebar.showMessageBar = true;
    }

    public isSignedIn() {
        return !this.userSessionManagerService.isGuest();
    }

    public getSignInLink() {
        return this.ngrsService.signInLinkRequest;
    }

    public isDigitalOffer() {
        return this.isdigitaloffer;
    }
    public hasDigitalBestOffer() {
        return this.digitalbestoffer !== undefined;
    }

    public digitalFormValidationCheck() {
        if(this._formData.myEmail === this._alternativeEmailCode && !this._formData.myAlternativeEmail) {
            this._isDigitalFormValid = false;
        }
        else if (!this._isLargeForm) {
            this._isDigitalFormValid = true;
        }
        else {
            this.checkChapterEnabledFieldsValidation();
            this._isDigitalFormValid = this.isChapterFormValid;
        }
    }

    public isDigitalFormValidation() {
        return this._isDigitalFormValid;
    }

    public isJournalFormValidation() {
        return this._isPhysicalJournalFormValid;
    }

    public isEBookFormValidation() {
        return this._isEBookFormValid;
    }

    public journalFormValidationCheck() {
        if(!this.isDigitalOffer() && isShowPhysicalJournalOffer()){
            if (this.isCodeEnabledforForm('VOLUME') || this.isCodeEnabledforForm('PUBLICATION_DATE')) {
                if (!this._formData.myPublicationDate && !this._formData.myVolume) {
                    this._isPhysicalJournalFormValid = false;
                    return false;
                }
            }
        } else {
            if (this._formData.myEmail === this._alternativeEmailCode && !this._formData.myAlternativeEmail) {
                return false;
            }

            if (this.isCodeEnabledforForm('ARTICLE_TITLE')) {
                if (this._formData.myArticleTitle) {
                    return true;
                } else {
                    return false;
                }
            }
        }
        
        return true; 
    }

    public musicFormValidationCheck() {
        this._isDigitalFormValid = false;
        if (this.isCodeEnabledforForm('FROM_PAGE_TO_PAGE') || this.isCodeEnabledforForm('OPUS') || this.isCodeEnabledforForm('SONG_MOVEMENT') || this.isCodeEnabledforForm('PART')){
            if(!this._formData.myOpus && 
                !this._formData.mySongMovement && 
                !this._formData.myPart && 
                !(this._formData.myFromPage && this._formData.myToPage)){
                this._isDigitalFormValid = false;
            } else{
                this._isDigitalFormValid = true;
            }
        }
        return this._isDigitalFormValid;
    }

    public validateMandatoryFields() {
        let currentElements = [];
        let formFieldElements = document.getElementsByClassName("form_field");
        if (formFieldElements) {
            for (let i = 0; i < formFieldElements.length; i++) {
                if (formFieldElements[i].id) {
                    currentElements.push(formFieldElements[i].id);
                }
            }
        }

        let pageFieldElements = document.getElementsByClassName("form_field_2");
        if (pageFieldElements) {
            for (let i = 0; i < pageFieldElements.length; i++) {
                if (pageFieldElements[i].id) {
                        currentElements.push( pageFieldElements[i].id)
                }
            }
        }

        for (let i = 0; i < currentElements.length; i++) {
            switch (currentElements[i]) {
                case 'ARTICLE_AUTHOR':
                    if (this._articleAuthorField.mandatory && !this._formData.myArticleAuthor) {
                        return false;
                    }
                    break;
                case 'ARTICLE_TITLE':
                    if (this._articleTitleField.mandatory && !this._formData.myArticleTitle) {
                        return false;

                    }
                    break;
                case 'CHAPTER_AUTHOR':
                    if (this._chapterAuthorField.mandatory && !this._formData.myChapterAuthor) {
                        return false;

                    }
                    break;
                case 'CHAPTER_NUMBER':
                    if (this._chapterNumberField.mandatory && !this._formData.myChapterNumber) {
                        return false;

                    }
                    break;
                case 'CHAPTER_TITLE': if(this._chapterTitleField.mandatory && !this._formData.myChapterTitle){
                    return false;
                }
                    break;
                case 'COMPOSER':
                    if (this._composerField.mandatory && !this._formData.myComposer) {
                        return false;

                    }
                    break;
                case 'EMAIL':
                    if (this._emailField.mandatory && !this._formData.myEmail) {
                        return false;

                    }
                    break;
                case 'ISSUE':
                    if (this.issueField.mandatory && !this._formData.myIssue) {
                        return false;

                    }
                    break;
                case 'LEVEL_OF_SERVICE_DIGITAL':
                    if (this._levelOfServiceField.mandatory && !this._formData.myLevelOfService) {
                        return false;

                    }
                    break;
                case 'LEVEL_OF_SERVICE_PHYSICAL':
                    if (this._levelOfServiceField.mandatory && !this._formData.myLevelOfService) {
                        return false;

                    }
                    break;
                case 'NOT_NEEDED_AFTER':
                    if (this._dateField.mandatory && !this._formData.myDate) {
                        return false;

                    }
                    break;
                case 'NOTE':
                    if (this._noteField.mandatory && !this._formData.myNote) {
                        return false;

                    }
                    break;
                case 'OPUS':
                    if (this._opusField.mandatory && !this._formData.myOpus) {
                        return false;

                    }
                    break;
                case 'PART':
                    if (this._partField.mandatory && !this._formData.myPart) {
                        return false;
                    }
                    break;
                case 'PICKUP_INSTITUTION':
                    if (this._pickupInstitutionFNField.mandatory && !this._formData.myPickupInstitution) {
                        return false;
                    }
                    break;
                case 'PICKUP_LOCATION':
                    if (this._locationField.mandatory && !this._formData.myLocation) {
                        return false;
                    }
                    break;
                case 'PICKUP_LOCATION_FOR_EBOOK':
                    if (this._locationFieldForEBookRequest.mandatory && !this._formData.myLocationForEBook) {
                        return false;
                    }
                    break;
                case 'PUBLICATION_DATE':
                    if (this._publicationDateField.mandatory && !this._formData.myPublicationDate) {
                        return false;
                    }
                    break;
                case 'SONG_MOVEMENT':
                    if (this._songMovementField.mandatory && !this._formData.mySongMovement) {
                        return false;
                    }
                    break;
                case 'VOLUME':
                    if (this._volumeField.mandatory && !this._formData.myVolume) {
                        return false;
                    }
                    break;
                case 'FROM_PAGE': if(this._fromPageField.mandatory && !this._formData.myFromPage) {
                    return false;
                }
                    break;
                case 'TO_PAGE': if(this._toPageField.mandatory && !this._formData.myToPage) {
                    return false;
                }
                    break;
                case 'ALTERNATIVE_EMAIL': if (this._alternativeEmailField.mandatory && !this._formData.myAlternativeEmail){
                    return false;
                }
                break;
                default:
                    break;
            }
        }

        return true;
    }

    public isFormValid(){
        if (!this.validateMandatoryFields()){
            return false;
        }

        //journal request
        if (this.isJournal()) {
            return this.journalFormValidationCheck();
        }

        if(this.isMusic() && this.isdigitaloffer){
             return this.musicFormValidationCheck();
        }

        // physical last resort request
        if (!this.isFNRotaOffer() && this.isblankform && !this.isdigitaloffer && this._formData.myLocation) {
            if (!this._allowOtherFormats.checked) {
                return true;
            } else if (this._formData.myEmail) {
                return true;
            }
        }

        if (this.isFNRotaOffer() && this.isblankform && !this.isdigitaloffer && this.pickupInstitutionAndLocationValid()) {
            if (!this._allowOtherFormats.checked) {
                return true;
            } else if (this._formData.myEmail) {
                return true;
            }
        }
        // digital last resort request
        else if (this.isblankform && this.isdigitaloffer && this._formData.myEmail) {
            this.digitalFormValidationCheck();
            if (this._isDigitalFormValid) {
                if (!this._allowOtherFormats.checked || this._formData.myLocation) {
                    return true;
                }
            }
        }
        // digital request
        else if (!this.isblankform && this.isdigitaloffer && this._formData.myEmail) {
            this.digitalFormValidationCheck();
            if (this._isDigitalFormValid) {
                return true;
            } else {
                return false;
            }
        }
        // physical request
        else if (this.isFNRotaOffer() && !this.isblankform && !this.isdigitaloffer && (this._pickupAnywhereEnabled || this.pickupInstitutionAndLocationValid())){
            return true;
        }

        else if (!this.isFNRotaOffer() && !this.isblankform && !this.isdigitaloffer && (this._formData.myLocation || this._pickupAnywhereEnabled)) {
            return true;
        }

        //we will enter here if we have no pickup location for the eBook request
        if(this.isEbookOffer() && !(this._locationFieldForEBookRequest.options.length || this._pickupAnywhereEnabled)){
            this._isEBookFormValid = false;
        } else if (this.isEbookOffer() && (this._locationFieldForEBookRequest.options.length || this._pickupAnywhereEnabled)){
            if(!this._formData.myLocationForEBook){
                this._formData.myLocationForEBook = this._locationFieldForEBookRequest.options[0].value;
            }
            return true;
        }

        return false;
    }

    private pickupInstitutionAndLocationValid(){
        if (this.isCodeEnabledforForm('PICKUP_LOCATION') &&  this.isCodeEnabledforForm('PICKUP_INSTITUTION')){
            return this._formData.myPickupInstitution && this._formData.myPickupLibrary;
        } else if (this.isCodeEnabledforForm('PICKUP_LOCATION')){
            return this._formData.myLocation;
        } else{
            return true;
        }
    }

    public isCopyRightsApproved() {
        return (this.isShowCopyRightsStatement() && this._copyRightsCheckBoxField.options[0].value == true) || !this.isShowCopyRightsStatement();
    }

    public getOfferLoanPeriod() {
        return this._bestOffer.loanPeriod;
    }

    public getOfferSupplyTime() {
        if(this._bestOffer){
            return this._bestOffer.supplyTime;
        }
        return undefined;
    }
    public getDigitalOfferSupplyTime() {
        if(this.digitalbestoffer)
            return this.digitalbestoffer.supplyTime;
        return undefined;
    }

    public showAlternativeEmail() {
        if (this._formData.myEmail && this._formData.myEmail === this._alternativeEmailCode) {
           this.focusOnByName(this.alternativeEmailField.name);
            return true;
        }
        this.focusedAlternativeEmail = false;
        return false;
    }

    public focusOnByName(elmName) {
        let elm = document.getElementsByName(elmName)[0];
        if (elm && !this.focusedAlternativeEmail ) {
            this.focusedAlternativeEmail = true;
            this.$timeout(() => {
                this.smoothScrollUtil.focusOn(elm);
            }, 400);
        }
    }
    
    // old method. discarard after December 22
	    // public getRequestHtml() {
    //     let rsrctype = this.getResourceType();
    //     let filePath = 'components/search/fullView/ngrs/getItRequest/';
    //         console.log("this")
    //         console.log(this)
        
    //     if(rsrctype == 'journal' || rsrctype == 'ejournal'){
    //         filePath += 'jornalGetItRequest.html';
    //     }else if(rsrctype == 'score'){
    //         filePath += 'musicGetItRequest.html';
    //     }else if(rsrctype == 'proceeding'){
    //         filePath +=  this.getProceedingHtml();
    //     }else if (this.isblankform ) {
    //         console.error("this is a blank form and should be fixed")
    //         console.error(this)
    //         filePath += lastResortHtml;
    //     }else if(rsrctype == 'book'){
    //         filePath += largeHtml;
    //     }else{
    //         let rsType = getGenreType(this.item)
    //         if(!rsType || rsType == 'unknown'){
    //             let issn = get(this.item, 'pnx.addata.issn[0]');
    //             if(issn){
    //                return filePath + smallHtml;
    //             }
    //         }
    //         filePath += largeHtml;
    //     }
    //     console.log(filePath)
    //     return filePath ;
    // }
    public getRequestHtml() {
        let rsrctype = getResourceType(this.item);
        let filePath = 'components/search/fullView/ngrs/getItRequest/';
        switch (rsrctype) {
            case 'journal':
                if(isShowPhysicalJournalOffer() && !this.isdigitaloffer){
                    this._isLargeForm = true;
                    filePath += largeHtml;
                    break;
                } else{
                    filePath += 'jornalGetItRequest.html';
                    break;
                }
            case 'ejournal':
                filePath += 'jornalGetItRequest.html';
                break;
            case 'proceeding':
                filePath +=  this.getProceedingHtml();
                break;
            case 'book':
            case 'dissertation':
                this._isLargeForm = true;
                filePath += largeHtml;
                break;
            case 'score':
                filePath += 'musicGetItRequest.html';
                break;
            default:
                let rsType = getGenreType(this.item);
                if(rsType && rsType !== 'unknown'){
                    filePath += smallHtml;
                    break;
                }
                let issn = get(this.item, 'pnx.addata.issn[0]');
                if(issn){
                    filePath += smallHtml;
                    break;
                }
                this._isLargeForm = true;
                filePath += largeHtml;
                break;
            }
            return filePath;
    }

    public isAllowOtherFormatsChecked() {
        return this._allowOtherFormats.checked;
    }

    public getProceedingHtml() {
       if(this.isProceedingWithPageMD()){
           return smallHtml;
       }
       this._isLargeForm = true;
        return largeHtml;
    }

    public isPartOf() {
        let resourceType = getResourceType(this.item);
        if (resourceType == 'bookitem' || resourceType == 'article' ) {
            return true;
        }
        return false;
    }

    public isJournal() {
        let resourceType = getResourceType(this.item);
        if (resourceType == 'journal' || resourceType == 'ejournal') {
            return true;
        }
        return false;
    }

    public isBook() {
        let resourceType = getResourceType(this.item);
        if (resourceType == 'book') {
            return true;
        }
        return false;
    }

    public isMusic() {
        let resourceType = getResourceType(this.item);
        if (resourceType == 'score') {
            return true;
        }
        return false;
    }    
    
    public isProceedingWithPageMD() {
        if(this.item &&  this.item.pnx && this.item.pnx.addata){
            let data = this.item.pnx.addata;
            return data.pages !== undefined || (data.spage !== undefined && data.epage !== undefined);
        }
        return false;
    }

    private closeKeydownSupport(e) {
        if (e.keyCode === 9) {
            e.preventDefault();
            let element = document.querySelector('#offer_request_main_tile') as HTMLElement;
            if (element) {
                element.focus();
            } else {
                element = document.querySelector('#no_offer_request_main_tile') as HTMLElement;
                if (element) {
                    element.focus();
                }
            }
        }
    }

    private saveKeydownSupport(e) {
        if (e.keyCode === 9) {
            e.preventDefault();
            let element = document.querySelector('#form-close-btn') as HTMLElement;
            if (element) {
                element.focus();
            }
        }
    }

    public get copyRightsCheckBoxField() {
        return this._copyRightsCheckBoxField;
    }

    public isShowCopyRightsStatement() {
        if (this.isblankform && !this.isShowCopyRightsOnBlankForm()) {
            return false;
        }
        return this._showCopyRightsStatement;
    }
    public isShowCopyRightsOnBlankForm() {
        return ((this.isdigitaloffer || this.isPartOf()) || (this.isAllowOtherFormatsChecked() && !this.isdigitaloffer));
    }

    public updateCopyRightsValue() {
        this._copyRightsCheckBoxField.options[0].value = !this._copyRightsCheckBoxField.options[0].value;
    }

    getResourceTypeLabel() {
        let resourceType = get(this.item, 'pnx.display.type[0]','b').toLowerCase();
        switch (resourceType) {
            case 'article': return this.$translate.instant('nui.ngrs.form.description.article');
            case 'audio': return this.$translate.instant('nui.ngrs.form.description.audio');
            case 'book': return this.$translate.instant('nui.ngrs.form.description.book');
            case 'bookchapter': return this.$translate.instant('nui.ngrs.form.description.bookChapter');
            case 'collection': return this.$translate.instant('nui.ngrs.form.description.collection');
            case 'conference_proceeding': return this.$translate.instant('nui.ngrs.form.description.conference_proceeding');
            case 'database': return this.$translate.instant('nui.ngrs.form.description.database');
            case 'dissertation': return this.$translate.instant('nui.ngrs.form.description.dissertation');
            case 'governmentdocument': return this.$translate.instant('nui.ngrs.form.description.GovernmentDocument');
            case 'image': return this.$translate.instant('nui.ngrs.form.description.image');
            case 'journal': return this.$translate.instant('nui.ngrs.form.description.journal');
            case 'kit': return this.$translate.instant('nui.ngrs.form.description.kit');
            case 'legaldocument': return this.$translate.instant('nui.ngrs.form.description.LegalDocument');
            case 'manuscript': return this.$translate.instant('nui.ngrs.form.description.manuscript');
            case 'map': return this.$translate.instant('nui.ngrs.form.description.map');
            case 'newspaper': return this.$translate.instant('nui.ngrs.form.description.newspaper');
            case 'newspaperarticle': return this.$translate.instant('nui.ngrs.form.description.NewspaperArticle');
            case 'other': return this.$translate.instant('nui.ngrs.form.description.other');
            case 'referenceentry': return this.$translate.instant('nui.ngrs.form.description.ReferenceEntry');
            case 'researchdataset': return this.$translate.instant('nui.ngrs.form.description.ResearchDataset');
            case 'review': return this.$translate.instant('nui.ngrs.form.description.Review');
            case 'score': return this.$translate.instant('nui.ngrs.form.description.score');
            case 'statisticaldataset': return this.$translate.instant('nui.ngrs.form.description.StatisticalDataSet');
            case 'technicalreport': return this.$translate.instant('nui.ngrs.form.description.TechnicalReport');
            case 'text_resource': return this.$translate.instant('nui.ngrs.form.description.text_resource');
            case 'video': return this.$translate.instant('nui.ngrs.form.description.video');
            case 'website': return this.$translate.instant('nui.ngrs.form.description.website');
            case 'print_book': return this.$translate.instant('nui.ngrs.form.description.print_book');
            case 'book_chapter': return this.$translate.instant('nui.ngrs.form.description.book_chapter');
            case 'report': return this.$translate.instant('nui.ngrs.form.description.report');
            case 'journal_article': return this.$translate.instant('nui.ngrs.form.description.journal_article');
            case 'conference-paper': return this.$translate.instant('nui.ngrs.form.description.Conference-Paper');
            default: return resourceType;
        }
    }

    public isShowRequestSpinner() {
        return this._requestSubmitted && !this.showmessagebar.showMessageBar;
    }

    public requestSubmitted() {
        return this._requestSubmitted;
    }

    public noOfferAfterRefineWithOtherMember() {
        return this.isOtherMemberPickupMode() && this._bestOffer._noOfferAfterRefine;
    }

    public sendDisabled() {
        return this._requestSubmitted || this.shouldRefineAfterChoosingPUAMember() || this.noOfferAfterRefineWithOtherMember() || this._refineOfferInProgress;
    }

    public isCodeEnabledforForm (code: string) {
        if(this.formscustomization && this.formscustomization.enabledCodesList){
            return this.formscustomization.enabledCodesList.includes(code);
        }
        return false;
    }

    public isCodeMandatoryForForm(code: string){
        if(this.formscustomization && this.formscustomization.mandatoryFieldsList){
            if(this.formscustomization.mandatoryFieldsList.includes(code)){
                return true;
            }
        }
        return false;
    }

    public checkChapterEnabledFieldsValidation(){
        if (this.isCodeEnabledforForm('FROM_PAGE_TO_PAGE') || this.isCodeEnabledforForm('CHAPTER_NUMBER') || this.isCodeEnabledforForm('CHAPTER_TITLE')){
            if(!this._formData.myChapterNumber && !this._formData.myChapterTitle && !(this._formData.myFromPage && this._formData.myToPage)){
                this.isChapterFormValid = false;
            } else{
                this.isChapterFormValid = true;
            }
        }
    }

    public isFNRotaOffer(){       
        if (this._bestOffer == null || typeof this._bestOffer === 'undefined' || typeof this._bestOffer.isFNRota === 'undefined'){
            return false;
        }
        return this._bestOffer.isFNRota;
    }

    public isFNRotaOfferDropDowns(){
        return this.isFNRotaOffer() && this.isCodeEnabledforForm('PICKUP_INSTITUTION') && this.isCodeEnabledforForm('PICKUP_LOCATION');
    }

    private setPickupInstitutionsLocation() {
        let comboOptions = [];
        if(this._pickupInstitutionAndLocationMap && this._pickupInstitutionAndLocationMap instanceof Array){
            this._pickupInstitutionAndLocationMap.forEach(element => {
                if(element.preferredPickupInstitution.key && element.preferredPickupInstitution.value){
                    comboOptions.push({ "label": element.preferredPickupInstitution.value, "value": element.preferredPickupInstitution.key});
                }
            });
        }
        comboOptions.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
        this._pickupLibraryFNField.options = [];       
        let defaultInstitutionValue = this.getDefaultInstitutionValue(comboOptions);
        if (defaultInstitutionValue) {
            this._pickupInstitutionFNField.mandatory = false;
            this._formData.myPickupInstitution = defaultInstitutionValue;
        }
        this._pickupInstitutionFNField.options = comboOptions;
        this.setPickupLibrariesLocation(true);
    }

    public setPickupLibrariesLocation(isDefault : boolean){
        let loginInstCode= getInstitutionCode();
        if(!this._pickupInstitutionFNField || !this._pickupInstitutionFNField.key){
            return;
        }
        this._formData.myPickupLibrary = null;
        let comboOptions = [];
        if (loginInstCode == this._formData.myPickupInstitution){
            forEach(this._pickupLocationLocal , (owner) => {
                comboOptions = this.parseOptions(owner.pickupLocation, comboOptions);
                comboOptions = this.parseOptions(owner.preferredLocalPickupLocation, comboOptions);
            });
        } else if(this._pickupInstitutionAndLocationMap && this._pickupInstitutionAndLocationMap instanceof Array){
            this._pickupInstitutionAndLocationMap.forEach(element => {
                if(element.preferredPickupInstitution.key == this._formData.myPickupInstitution){
                    if(element.preferredPickupLocation && element.preferredPickupLocation instanceof Array){
                        element.preferredPickupLocation.forEach(library => {
                            comboOptions.push({ "label": library.value, "value": library.key});
                        });
                    }
                    return;
                }
            });
        }
        comboOptions.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
        if (isDefault){
            let defaultLibraryValue = this.getDefaultLibraryValue(comboOptions);
            if (defaultLibraryValue) {
                this._pickupLibraryFNField.mandatory = false;
                this._formData.myPickupLibrary = defaultLibraryValue;
            }
        }
        this._pickupLibraryFNField.options = comboOptions;
    }

    private setPickupMember(any){
        if(this.isOtherMemberPickupMode()){
            this.switchLocationSubmenu(false)
            this._refined = false;
        } else {
            this.switchLocationSubmenu(true);
            if (this.bestoffer && this._bestOffer._noOfferAfterRefine){
                this.refineOffer();
            } else {
                this._canRestore = true;
            }
        }
    }

    private switchLocationSubmenu(on: boolean){
        this._locationField.mandatory = on ? this.isPickupLocationFieldMandatory() : false;
        this._locationField.mandatoryIndicator = this._locationField.mandatory;
        this._showSubMenuForPua = on;
    }

    private getDefaultInstitutionValue(comboOptions: any[]) {
        if (comboOptions.length == 1) {
            return comboOptions[0].value
        }
        const defaultValueIndexFilter = (element) => element.value == this._pickupInstitutionDefault;
        let defaultValueIndex = comboOptions.findIndex(defaultValueIndexFilter);
        if (defaultValueIndex > -1) {
            return comboOptions[defaultValueIndex].value;
        }
    }

    private getDefaultLibraryValue(comboOptions: any[]) {
        if (comboOptions.length == 1) {
            return comboOptions[0].value
        }
        const defaultValueIndexFilter = (element) => element.value == this._pickupLibraryDefault;
        let defaultValueIndex = comboOptions.findIndex(defaultValueIndexFilter);
        if (defaultValueIndex > -1) {
            return comboOptions[defaultValueIndex].value;
        }
    }

    public get pickupInstitutionFNField() {
        return this._pickupInstitutionFNField;
    }

    public get pickupLibraryFNField() {
        return this._pickupLibraryFNField;
    }

    public isPhysicalJournal(){
        let resourceType = getResourceType(this.item);
        if(resourceType == 'journal' && isShowPhysicalJournalOffer()){
            return true;
        }
        return false;
    }

    public refineOfferIsVisible(){
        if (this.isPuaOffer() && !this._refineOfferInProgress){
            return true;
        } else if((this.isPhysicalJournal() && (this.isCodeEnabledforForm('VOLUME') || this.isCodeEnabledforForm('PUBLICATION_DATE')) && !this._refineOfferInProgress)){
            return true;
        } else if(!this.isPhysicalJournal() && this.isCodeEnabledforForm('VOLUME') && !this._refineOfferInProgress){
            return true;
        }
        return false;
    }

    public getRefineButtonTooltip(){
        if (this.isPuaOffer()){
            return "rapido.tiles.physical.refineOfferPickup.tooltip";
        }
        return "rapido.tiles.physical.refineOffer.tooltip";
    }


    public onPhysicalJournalFieldChange(newValue, oldValue){
        if(this.isPhysicalJournal() && !this.isDigitalOffer()){
            this._bestOffer = this.getNoOfferOfferDetails();
            this._isPhysicalJournalFormValid = true;
        }
    }

    public isEbookOffer(){       
        if (!this._bestOffer || !this._bestOffer.ebookOffer){
            return false;
        }
        return this._bestOffer.ebookOffer;
    }

    public isOtherMemberPickupMode(){
        if (!this._isPuaOffer){
            return false;
        }
        return this._formData.myPickupMember != -1;
    }

    public isPuaOffer(){
        return this._bestOffer != undefined
            && this._bestOffer.puaCentralMembers != undefined
            && Object.keys(this._bestOffer.puaCentralMembers).length > 0
            && !this.isEbookOffer();
    }

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/getItRequest/getItRequest.directive.ts